export default "__VITE_ASSET__BHjPFiIR__"